export enum ClaimCoverageEnum {
  APARTAMENTO_HABITUAL_VERANEIO = 'APARTAMENTO_HABITUAL_VERANEIO',
  CASA_HABITUAL_VERANEIO = 'CASA_HABITUAL_VERANEIO',
  PREDIO_CONTEUDO_PREDIO_MAIS_CONTEUDO = 'PREDIO_CONTEUDO_PREDIO_MAIS_CONTEUDO',
  INCENDIO_RAIO_EXPLOSAO_FUMACA_QUEDA_AERONAVE = 'INCENDIO_RAIO_EXPLOSAO_FUMACA_QUEDA_AERONAVE',
  DANOS_ELETRICOS = 'DANOS_ELETRICOS',
  RC_FAMILIAR = 'RC_FAMILIAR',
  VENDAVAL_FURACAO_CICLONE_TORNADO_GRANIZO = 'VENDAVAL_FURACAO_CICLONE_TORNADO_GRANIZO',
  PERDA_PAGAMENTO_ALUGUEL = 'PERDA_PAGAMENTO_ALUGUEL',
  ROUBO_FURTO_QUALIFICADO_BENS = 'ROUBO_FURTO_QUALIFICADO_BENS',
  QUEBRA_VIDROS_MARMORE_GRANITO = 'QUEBRA_VIDROS_MARMORE_GRANITO',
  IMPACTO_VEICULOS = 'IMPACTO_VEICULOS',
  DESMORONAMENTO = 'DESMORONAMENTO',
  DESPESAS_EXTRAORDINARIAS = 'DESPESAS_EXTRAORDINARIAS',
  EQUIPAMENTOS_ELETRONICOS = 'EQUIPAMENTOS_ELETRONICOS',
  ROUBO_FURTO_QUALIFICADO_BENS_FORA_LOCAL_SEGURADO = 'ROUBO_FURTO_QUALIFICADO_BENS_FORA_LOCAL_SEGURADO',
  RUPTURA_TANQUES_TUBULACOES = 'RUPTURA_TANQUES_TUBULACOES',
  TUMULTOS_GREVES_LOCKOUTS = 'TUMULTOS_GREVES_LOCKOUTS',
  ALAGAMENTO = 'ALAGAMENTO'
}
